<template>
  <label :class="['radio-card', { selected, disabled }]">
    <input
      type="radio"
      class="form-check-input"
      :checked="selected"
      :disabled="disabled"
      @change="$emit('select')"
    />
    <div class="radio-card-text">
      <div class="radio-card-label">{{ label }}</div>
      <div v-if="description" class="radio-card-description">{{ description }}</div>
      <slot />
    </div>
  </label>
</template>

<script>
export default {
  props: {
    label: String,
    description: String,
    selected: Boolean,
    disabled: Boolean
  },
  emits: ['select']
}
</script>

<style scoped>
.radio-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--bs-border-color);
  border-radius: 7px;
  cursor: pointer;
  transition: border-color 0.15s;
  margin-bottom: 0;
}
.radio-card:hover:not(.disabled) {
  border-color: var(--bs-gray-500);
}
.radio-card.selected {
  border-color: var(--bs-dark);
}
.radio-card.disabled {
  opacity: 0.6;
  cursor: default;
}
.radio-card .form-check-input {
  margin-top: 2px;
  flex-shrink: 0;
}
.radio-card .form-check-input:checked {
  background-color: var(--bs-dark);
  border-color: var(--bs-dark);
}
.radio-card-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.radio-card-label {
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.3;
}
.radio-card-description {
  font-weight: 400;
  font-size: 0.8rem;
  color: var(--bs-secondary-color);
  line-height: 1.3;
}
</style>
